import { Link } from 'react-router'
import WatchCTA from '#app/routes/resources+/watch-cta.tsx'

export const meta = () => {
	const title = 'JaseOwns - Gaming - EverQuest'
	const description =
		'EverQuest is one of my most-played games of all time. From the original grind to EverQuest Legends today, Norrath keeps pulling me back.'
	return [
		{ title: title },
		{ description: description },
		{
			name: 'keywords',
			content: 'everquest,eq,norrath,mmo,1999,everquest legends',
		},
		{ property: 'twitter:card', content: 'summary' },
		{ property: 'twitter:creator', content: '@jaseowns' },
		{ property: 'twitter:site', content: '@jaseowns' },
		{ property: 'og:title', content: title },
		{ property: 'og:description', content: description },
	]
}

export default function Index() {
	return (
		<div className="container mx-auto text-black dark:text-white">
			<section id="gaming">
				<h1 className="text-3xl px-10 mb-8 text-cyan-900 dark:text-cyan-200">
					<Link to="/gaming" className="underline">Gaming</Link> - EverQuest
				</h1>
				<div className="px-10">
					<div className="my-6 space-y-4">
						<p>
							EverQuest sits right next to Ultima Online on my list of
							most-played games of all time. Where{' '}
							<Link to="/gaming/ultima-online" className="underline">UO</Link>{' '}
							was the open sandbox, EverQuest was the world that demanded
							commitment — corpse runs, camp checks, and the very real fear of
							the train to zone.
						</p>
						{/* TODO(jase): add your personal EQ story here — first character,
						    server, the memory that hooked you. Same style as the UO page. */}
					</div>

					<h2 className="text-3xl my-6 text-cyan-900 dark:text-cyan-200">
						Do you still play?
					</h2>
					<div className="my-6 space-y-4">
						<p>
							I do — these days through{' '}
							<Link to="/gaming/everquest-legends" className="underline">
								EverQuest Legends
							</Link>
							, Daybreak's new take on Norrath. I stream it on YouTube and
							Twitch, including my{' '}
							<Link to="/gaming/everquest-legends/dungeon-runs" className="underline">
								Dungeon Runs
							</Link>{' '}
							project: fresh character, long road, one dungeon.
						</p>
					</div>
				</div>
			</section>

			<div className="flex flex-wrap justify-center gap-8 rounded-3xl py-4">
				{WatchCTA()}
			</div>
		</div>
	)
}
